import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row d-flex justify-content-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "input-text" }, "Temas", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "input-text" }, "Mascaras", -1)
const _hoisted_4 = { class: "row d-flex justify-content-end mt-2" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Limpiar")

import { AccountModule } from '@/store/modules/Account';
import { computed, ref, watch } from 'vue';
import { IReplies } from '@/store/modules/Account'
import { MessageModule } from '@/store/modules/Message';
import { TicketModule } from '@/store/modules/Ticket';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const model = ref({
	topic: "",
	subtopic: ""
});

watch(
	() => [model.value.topic],
	() => {
		model.value.subtopic = "";
		subtopics.value = topics.value.find(t => { return t._id == model.value.topic })?.replies.filter(r => r.active) ?? [];
	}
);

const topics = computed(() => AccountModule.topics)

const subtopics = ref<IReplies[]>([]);

const pushMessage = () => {
	MessageModule.refreshCurrentMessage(
		subtopics.value.find(st => {
			return st.message == model.value.subtopic
		})?.message ?? ""
	)
}

const clear = () => {
	MessageModule.refreshCurrentMessage("");
	TicketModule.setTypingMessage({ roomId: TicketModule.currentRoomID ?? "", message: "" });
	model.value.topic = "";
	model.value.subtopic = "";
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_col, { class: "fs-base" }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_select, {
        class: "col-12 my-2 px-0",
        size: "small",
        modelValue: model.value.topic,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model.value.topic) = $event)),
        placeholder: "Seleccione el tema"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(topics), (topic) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: topic._id,
              label: topic.subject,
              value: topic._id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_col, { class: "fs-base" }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_el_select, {
        class: "col-12 my-2 px-0",
        size: "small",
        modelValue: model.value.subtopic,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model.value.subtopic) = $event)),
        onChange: pushMessage,
        placeholder: "Seleccione la mascara"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subtopics.value, (subtopic, i) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: i,
              label: subtopic.mask,
              value: subtopic.message
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_button, {
        class: "",
        type: "default",
        onClick: clear,
        plain: ""
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})